<template>
    <div class="ts-widget" v-if="dataLoaded && data.feedbacks.length > 0">
        <div class="fxc">
            <div class="h1 dot">{{ $attrs.headline }}</div>
            <div class="top">
                <div class="rate">
                    <div class="rating-txt">
                        <div class="stars">
                            <span class="blank">
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                            </span>
                            <span class="full" :style="'width:' + parseFloat(data.fb_avg) * 20 + '%'">
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                            </span>
                        </div>
                        <div><strong>{{ data.fb_avg.replace('.0','') }}/5</strong> ({{ data.fb_count_total }} {{ $attrs.text }})</div>
                    </div>
                    <p>{{ $attrs.itemName }}</p>
                </div>
                <i class="icon-ekomigold"></i>
                <i class="icon-ekomigoldxxl"></i>
            </div>

            <ul>
                <template v-for="(feedback, index) in data.feedbacks">
                    <li>
                        <div>
                            <span>
                                <i v-for="n in Number(feedback.rating)" class="fa fa-star"></i>
                                <i v-for="n in (5 - Number(feedback.rating))" v-if="Number(feedback.rating) < 5" class="fa fa-star grey" ></i>

                                <strong>{{ feedback.date }}</strong>
                            </span>
                            <div class="txt" v-html="feedback.review"></div>
                        </div>
                    </li>
                    <input type="checkbox" id="showMore" v-if="data.feedbacks.length > 4 && index == 3">
                    <label for="showMore" v-if="data.feedbacks.length > 4 && index == 3">{{ $attrs.more }}</label>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                data:[],
                dataLoaded: false
            }
        },
        mounted() {
            var self = this,
            data = [];

            $.getJSON('https://teppichversand24.net/cyt/ekomi/fb/fbget?id=' + this.$attrs.itemId + '&lang=' + this.$attrs.lang + '&limit=100').done(function( data ) {
                self.data = data;
                self.dataLoaded = true;
            })
        }
    }
</script>
